import '@ant-design/compatible/assets/index.css';
import { useQuery } from 'react-query';
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import {
  Spin,
  Row,
  Card,
  Col,
  DatePicker,
  Divider,
  message,
  InputNumber,
} from 'antd';
import DF from 'DisplayFramework';
import { toCurrency } from 'utils/utils';
import Text from 'antd/lib/typography/Text';
import Form, { FormInstance } from 'antd/lib/form';
import * as finEngine from 'services/finEngine';
import { isNil, sumBy } from 'lodash';
import { dateToString, toDatePickerDate } from 'utils/utils2';
import { useForm } from 'antd/lib/form/Form';
import GetLabel from 'DisplayFramework/components/GetLabel';
import FormInput from 'components/FormInput';
import UtinaCard from 'components/UtinaCard';
import Value from 'components/Value';
import {
  AssetFutureValues,
  getAssetValues,
  GetAssetValuesParams,
  getFinAssetsByID,
} from 'services/finassets';
import moment from 'moment';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataTable/DataTable';
import TextArea from 'antd/lib/input/TextArea';
import InputCurrency from 'components/InputCurrency';
import ParListSelect from 'components/ParListSelect';
import PricingListFilteredSelect from 'components/PricingListFilteredSelect';
import { PricingResponse } from 'services/pricing';

export type TabEvaluateAssetProps = {
  objectid: number;
  status: string;
  statusdate: string;
  form: FormInstance;
  setSuccessful?: any;
};

const TabEvaluateAsset = ({
  objectid,
  statusdate,
  form: formW,
  setSuccessful,
}: TabEvaluateAssetProps) => {
  const [form] = useForm();
  const [state, setState] = useState<any>({
    saleamount: 0,
    marketvalueasis: 0,
    gainifsale: 0,
    gainifrecond: 0,
    currcode: localStorage.getItem('currcode') ?? '',
  });

  const calculateFees = (pricing?: PricingResponse, ctetype?: string) => {
    if (pricing) {
      let totalamount = sumBy(state.listAssets, 'assetnetamount');

      finEngine
        .calculateServiceWithStep({
          servReq: {
            finSchedule: [],
            inDownPayment: 0,
            inFinAmount: state.currentOutstanding ?? 0,
            inFollowGP: true,
            inGPDuration: 0,
            inPstype: pricing?.ctecategory ?? '',
            inRoudingAmount: 2,
            inServcalculationmethod:
              pricing?.serviceResponse.servcalculationmethod ?? '',
            inServfixedamount: pricing?.serviceResponse.servfixedamount ?? 0,
            inServiceduration: pricing?.serviceResponse.servduration ?? '',
            inServpercentage: pricing?.serviceResponse.servpercentage ?? 0,
            inTaxcode: pricing?.taxcode ?? '',
            inTaxrate: pricing?.taxrate ?? 0,
            inDuration: 0,
            inInvestAmount: totalamount,
            inAssetAmount: totalamount,
            inServperiodicity: pricing?.serviceResponse.servperiodicity ?? '1',
            inServDurationFree:
              pricing?.serviceResponse.servdurationdefault ?? 1,
            inStartDate: form?.getFieldValue('evaluationdate'),
            inServbasis: pricing?.serviceResponse.servbasis ?? 'FLAT',

            inCalculatedamountbasis:
              pricing?.serviceResponse.calculatedamountbasis ?? 'FINANCING',

            inMarginoncalcultedamount:
              pricing?.serviceResponse.marginoncalulatedamount ?? 0,
            inAdditionalcostaftermargin:
              pricing?.serviceResponse.additionalcostaftermargin ?? 0,

            servStep: pricing?.serviceStepList ?? [],
          },
        })
        .then((res) => {
          if (res.success) {
            message.success('Service - ' + res.message);

            let coef = state.listAssets?.length;

            // //

            const feesamount = state.feesamount ?? 0;

            if (ctetype === 'TPOF') {
              let totalinvoiceamount =
                Number(state.totalsaleamount) +
                Number(state.totaldegfeesamount) +
                Number(res.installmentamount) +
                Number(state.totalspamount) +
                feesamount;

              let totaltpofamount = res.installmentamount;

              let listAssets = state.listAssets.map((asset: any) => {
                let newtotal = 0;
                if (form?.getFieldValue('targetphase') === 'ASSETOUT') {
                  newtotal = asset.saleamount + res.installmentamount / coef;
                } else {
                  newtotal =
                    asset.degfeesamount +
                    asset.spamount +
                    res.installmentamount / coef;
                }

                return {
                  ...asset,
                  tpofamount: res.installmentamount / coef,
                  totalinvoiceamount: newtotal,
                };
              });
              updateState({
                totalinvoiceamount: totalinvoiceamount,
                totaltpofamount: totaltpofamount,
                listAssets: listAssets,
              });

              form?.setFieldsValue({
                totalinvoiceamount: totalinvoiceamount,
                totaltpofamount: totaltpofamount,
                listAssets: listAssets,
              });
            } else {
              if (ctetype === 'DEGFEES') {
                let totalinvoiceamount =
                  Number(state.totalsaleamount) +
                  Number(res.installmentamount) +
                  Number(state.totaltpofamount) +
                  Number(state.totalspamount) +
                  feesamount;

                let totaldegfeesamount = res.installmentamount;

                let listAssets = state.listAssets.map((asset: any) => {
                  const newtotal =
                    !isNaN(asset.saleamount) &&
                    form?.getFieldValue('targetphase') === 'ASSETOUT'
                      ? asset.saleamount + asset.tpofamount
                      : asset.tpofamount +
                        asset.spamount +
                        res.installmentamount / coef;
                  return {
                    ...asset,
                    totalinvoiceamount: newtotal,
                    degfeesamount: res.installmentamount / coef,
                  };
                });
                updateState({
                  totalinvoiceamount: totalinvoiceamount,
                  totaldegfeesamount: totaldegfeesamount,
                  listAssets: listAssets,
                });
                form?.setFieldsValue({
                  totalinvoiceamount: totalinvoiceamount,
                  totaldegfeesamount: totaldegfeesamount,
                  listAssets: listAssets,
                });
              } else {
                // SPFEES :
                let spamount =
                  res.installmentamount * form?.getFieldValue('spvalue');

                updateState({
                  totalspamount: spamount,
                });
                form?.setFieldsValue({
                  spamount: spamount,
                });
              }
            }
          }
        });
    }
    // } // end if pricing
  };

  const { data, isFetching: loading } = useQuery(
    ['getFinAssetsByID', objectid],
    () =>
      getFinAssetsByID({ assetid: objectid! }).then((res) => {
        if (res.code === '403') {
          window.history.replaceState(null, '', '/403');
          window.location.reload();
        }
        return res.data;
      })
  );

  const updateAmountRecond = () => {
    const saleamount = form.getFieldValue('saleamount');
    const transportamount = form.getFieldValue('transportamount');
    const storageamount = form.getFieldValue('storageamount');
    const recondamount = form.getFieldValue('recondamount');
    const assetfinamount = form.getFieldValue('assetfinamount');
    const amount = saleamount - transportamount - storageamount - recondamount;
    const gainamount =
      saleamount -
      transportamount -
      storageamount -
      recondamount -
      assetfinamount;

    const actualmileage = form.getFieldValue('actualmileage');
    let contractualmileage= form?.getFieldValue('contractualmileage');


    console.log('actualmileage',actualmileage)
    console.log('contractualmillage',contractualmileage)


    let diff =  actualmileage -contractualmileage ;
   
  
    form?.setFieldValue('spvalue', diff > 0 ? diff?.toFixed(2) : 0);

    formW?.setFieldValue('spvalue', diff > 0 ? diff?.toFixed(2) : 0);

    formW.setFieldsValue({ gainifrecond: amount });
    form.setFieldsValue({ gainifrecond: amount });
    formW.setFieldsValue({ gainifsale: gainamount });
    form.setFieldsValue({ gainifsale: gainamount });
  };
  const updateState = useCallback(
    (values) => {
      setState((prev: any) => ({ ...prev, ...values }));
    },
    [setState]
  );
  const [searchParams, setSearchParams] = useState<GetAssetValuesParams>({
    assetid: objectid,
    valuedate: statusdate ?? moment().format('YYYY-MM-DD'),
  });

  const { data: assetValues, isFetching } = useQuery(
    ['getAssetValues', searchParams],
    () =>
      getAssetValues(searchParams).then((res) => {
        setSuccessful(false);
        return res.data || [];
      }),
    {
      enabled: !isNil(objectid),
    }
  );

  useEffect(() => {
    setSuccessful(isFetching);
  }, [isFetching]);

  useEffect(() => {
    if (assetValues) {
      form.setFieldsValue({
        ...assetValues,
        marketvalueasis: assetValues.marketvalue,
        // contractualmileage: assetValues.usevalue,
        gainifrecond: 0,
        gainifsale: 0,
        damage: '',
        recondamount: 0,
        transportamount: 0,
        storageamount: 0,
        saleamount: 0,
        repcomment: '',
        repdecision: '',
      });
    }
    formW.setFieldsValue({
      event: 'TabEvaluateAsset',
      ...assetValues,
      marketvalueasis: assetValues?.marketvalue,
      gainifrecond: 0,
      gainifsale: 0,
      damage: '',
      recondamount: 0,
      transportamount: 0,
      storageamount: 0,
      saleamount: 0,
      repcomment: '',
      repdecision: '',
      repevaldate: form.getFieldValue('repevaldate') ?? statusdate,
      spamount: form.getFieldValue('spamount') ?? state.totalspamount,
    });
  }, [form, assetValues]);

  useEffect(() => {
    let startdate = moment(data?.assetdeliverydate);

    let repevaldate = form.getFieldValue('repevaldate');
    let duree = moment(repevaldate).diff(startdate, 'days');

    console.log('startdate', startdate);

    console.log('duree', duree);

    let mileagePerDay = data?.assetmileage ? data?.assetmileage / 365 : 0;

    console.log('mileagePerDay', mileagePerDay);

    let maxMileageToUse = mileagePerDay * duree;

    console.log('maxMileageToUse', maxMileageToUse);

    formW?.setFieldValue('contractualmileage', maxMileageToUse?.toFixed(2));

    form?.setFieldValue('contractualmileage', maxMileageToUse?.toFixed(2));
  }, [data, searchParams]);

  const columnsfv = useMemo<DataGridColDef<AssetFutureValues>[]>(
    () => [
      {
        dataIndex: 'contextcodelabel',
        width: 150,
      },
      {
        dataIndex: 'fvtypelabel',
        width: 150,
      },
      {
        dataIndex: 'fvamount',
        width: 150,
        render: (val) =>
          toCurrency(
            val,
            assetValues?.currcode ?? localStorage.getItem('currcode') ?? ''
          ),
      },
    ],
    []
  );
  return (
    <DF.Provider pagcode="TabEvaluateAsset">
      <Form
        form={form}
        onValuesChange={(val) => {
          if (val.valueamount)
            formW?.setFieldsValue({ valueamount: val.valueamount });

          if (val.repdecision)
            formW?.setFieldsValue({ repdecision: val.repdecision });

          if (val.repcomment)
            formW?.setFieldsValue({ repcomment: val.repcomment });

          if (val.marketvalueasis)
            formW?.setFieldsValue({ marketvalueasis: val.marketvalueasis });
          if (val.damage) formW?.setFieldsValue({ damage: val.damage });

          if (val.saleamount)
            formW?.setFieldsValue({ saleamount: val.saleamount });
          if (val.transportamount)
            formW?.setFieldsValue({ transportamount: val.transportamount });
          if (val.storageamount)
            formW?.setFieldsValue({ storageamount: val.storageamount });
          if (val.recondamount)
            formW?.setFieldsValue({ recondamount: val.recondamount });
          if (val.gainifrecond)
            formW?.setFieldsValue({ gainifrecond: val.gainifrecond });
          if (val.gainifsale)
            formW?.setFieldsValue({ gainifsale: val.gainifsale });
          // if (val.contractualmileage)
          //   formW?.setFieldsValue({
          //     contractualmileage: val.contractualmileage,
          //   });
          if (val.actualmileage)
            formW?.setFieldsValue({ actualmileage: val.actualmileage });
          // if (val.spvalue) formW?.setFieldsValue({ spvalue: val.spvalue });
          if (val.spformula)
            formW?.setFieldsValue({ spformula: val.spformula?.priid });
        }}
        layout="horizontal"
        labelCol={{ span: 10 }}
        wrapperCol={{ span: 16 }}
        labelAlign="left"
      >
        <Spin spinning={isFetching || loading}>
          <Row>
            <Col span={8}>
              <strong>
                <GetLabel label="evaluationdate" />
                &nbsp;
                <DatePicker
                  defaultValue={
                    toDatePickerDate(searchParams.valuedate) as moment.Moment
                  }
                  onChange={(date) => {
                    setSearchParams({
                      ...searchParams,
                      valuedate: dateToString(date),
                    });
                    form.setFieldsValue({ repevaldate: dateToString(date) });

                    let startdate = moment(data?.assetdeliverydate);

                    let repevaldate = form.getFieldValue('repevaldate');
                    let duree = moment(repevaldate).diff(startdate, 'days');

                    console.log('startdate', startdate);

                    console.log('duree', duree);

                    let mileagePerDay = data?.assetmileage
                      ? data?.assetmileage / 365
                      : 0;

                    console.log('mileagePerDay', mileagePerDay);

                    let maxMileageToUse = mileagePerDay * duree;

                    console.log('maxMileageToUse', maxMileageToUse);

                    formW?.setFieldValue(
                      'contractualmileage',
                      maxMileageToUse?.toFixed(2)
                    );

                    form?.setFieldValue(
                      'contractualmileage',
                      maxMileageToUse?.toFixed(2)
                    );
                  }}
                />
              </strong>
            </Col>
          </Row>
          <br />
          <Row>
            <UtinaCard
              level={5}
              comcode="asset"
              style={{ color: '#000', marginLeft: 30 }}
              lg={12}
            >
              <Row gutter={16}>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="statuslabel"
                  comcode="statuslabel"
                >
                  <Value />
                </FormInput>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="assetstatusdate"
                  comcode="assetstatusdate"
                >
                  <Value />
                </FormInput>
              </Row>
              <Row gutter={16}>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="deliverydate"
                  comcode="deliverydate"
                >
                  <Value />
                </FormInput>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="assetnetamount"
                  comcode="assetnetamount"
                >
                  <Value
                    formatter={(value) =>
                      toCurrency(
                        value,
                        assetValues?.currcode ??
                          localStorage.getItem('currcode') ??
                          ''
                      )
                    }
                  />
                </FormInput>
              </Row>
              <Row gutter={16}>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="assetfinamount"
                  comcode="assetfinamount"
                >
                  <Value
                    formatter={(value) =>
                      toCurrency(
                        value,
                        assetValues?.currcode ??
                          localStorage.getItem('currcode') ??
                          ''
                      )
                    }
                  />
                </FormInput>

                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="assetrvamount"
                  comcode="assetrvamount"
                >
                  <Value
                    formatter={(value) =>
                      toCurrency(
                        value,
                        assetValues?.currcode ??
                          localStorage.getItem('currcode') ??
                          ''
                      )
                    }
                  />
                </FormInput>
              </Row>
            </UtinaCard>
            <UtinaCard
              level={5}
              comcode="currentvalues"
              style={{ color: '#000', marginLeft: 30 }}
              lg={11}
            >
              <Row gutter={16}>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="assetfinrvamount"
                  comcode="assetfinrvamount"
                >
                  <Value
                    formatter={(value) =>
                      toCurrency(
                        value,
                        assetValues?.currcode ??
                          localStorage.getItem('currcode') ??
                          ''
                      )
                    }
                  />
                </FormInput>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="assetvaluesdate"
                  comcode="assetvaluesdate"
                >
                  <Value />
                </FormInput>
              </Row>
              <Row gutter={16}>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="assetirvamount"
                  comcode="assetirvamount"
                >
                  <Value
                    formatter={(value) =>
                      toCurrency(
                        value,
                        assetValues?.currcode ??
                          localStorage.getItem('currcode') ??
                          ''
                      )
                    }
                  />
                </FormInput>

                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="marketvalue"
                  comcode="marketvalue"
                >
                  <Value
                    formatter={(value) =>
                      toCurrency(
                        value,
                        assetValues?.currcode ??
                          localStorage.getItem('currcode') ??
                          ''
                      )
                    }
                  />
                </FormInput>
              </Row>
              <Row gutter={16}>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="marketvaluedate"
                  comcode="marketvaluedate"
                >
                  <Value />
                </FormInput>

                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="marketvalueorigin"
                  comcode="marketvalueorigin"
                >
                  <Value />
                </FormInput>
              </Row>
            </UtinaCard>
          </Row>
          <Row>
            <UtinaCard
              level={5}
              comcode="FuturesValues"
              style={{ color: '#000', marginLeft: 30 }}
              lg={10}
            >
              <DataGrid
                columns={columnsfv}
                dataSource={assetValues?.futureValues}
                pagination={false}
                rowKey="contextid"
                size="small"
                hideFilters
                bordered
              />
            </UtinaCard>

            <UtinaCard
              level={5}
              comcode="RepossessionEval"
              style={{ color: '#000', marginLeft: 30 }}
              lg={13}
            >
              <Row gutter={8}>
                <Col span={12}>
                  <FormInput
                    col
                    xs={24}
                    wrapperCol={{ span: 14 }}
                    // labelCol={{ span: 10 }}
                    labelAlign="left"
                    name="damage"
                  >
                    <ParListSelect
                      parcode="DAMLEVEL"
                      onChange={(dmg) => {
                        form?.setFieldsValue({
                          totaldegfeesamount: 0,
                          degfeesformula: null,
                        });
                      }}
                    />
                  </FormInput>

                  <FormInput labelAlign="left" col xs={24} name="degfeesamount">
                    <Text>
                      {toCurrency(
                        state.totaldegfeesamount,
                        assetValues?.currcode ??
                          localStorage.getItem('currcode')
                      )}
                    </Text>
                  </FormInput>

                  <FormInput
                    col
                    xs={24}
                    name="recondamount"
                    comcode="recondamount"
                  >
                    <InputCurrency
                      currcode={
                        assetValues?.currcode ??
                        localStorage.getItem('currcode') ??
                        ''
                      }
                      onChange={updateAmountRecond}
                    />
                  </FormInput>
                  <FormInput
                    col
                    xs={24}
                    name="transportamount"
                    comcode="transportamount"
                  >
                    <InputCurrency
                      currcode={
                        assetValues?.currcode ??
                        localStorage.getItem('currcode') ??
                        ''
                      }
                      onChange={updateAmountRecond}
                    />
                  </FormInput>
                  <FormInput
                    col
                    xs={24}
                    name="storageamount"
                    comcode="storageamount"
                  >
                    <InputCurrency
                      currcode={
                        assetValues?.currcode ??
                        localStorage.getItem('currcode') ??
                        ''
                      }
                      onChange={updateAmountRecond}
                    />
                  </FormInput>
                  <FormInput
                    col
                    xs={24}
                    name="contractualmileage"
                    comcode="contractualmileage"
                  >
                    <InputNumber onChange={updateAmountRecond} disabled />
                  </FormInput>

                  <FormInput col xs={24} name="spvalue" comcode="spvalue">
                    <InputNumber onChange={updateAmountRecond} />
                  </FormInput>
                </Col>
                <Col span={12}>
                  <FormInput
                    labelAlign="left"
                    col
                    xs={24}
                    name="degfeesformula"
                  >
                    <PricingListFilteredSelect
                      allowClear
                      disabled={state.isModSelected}
                      params={{
                        offerid: state?.offerid ?? 0,
                        ctetype: 'DEGFEES',
                        prcode: '',
                        entity: '',
                        entityid: 0,
                        tpid: 0,
                        filtersPricing:
                          'DAMLEVEL=' + form.getFieldValue('damage') + ',',
                      }}
                      onChange={(e) => calculateFees(e, 'DEGFEES')}
                    />
                  </FormInput>
                  <FormInput
                    col
                    xs={24}
                    name="marketvalueasis"
                    comcode="marketvalueasis"
                  >
                    <InputCurrency
                      currcode={
                        assetValues?.currcode ??
                        localStorage.getItem('currcode') ??
                        ''
                      }
                    />
                  </FormInput>
                  <FormInput col xs={24} name="saleamount" comcode="saleamount">
                    <InputCurrency
                      currcode={
                        assetValues?.currcode ??
                        localStorage.getItem('currcode') ??
                        ''
                      }
                      onChange={updateAmountRecond}
                    />
                  </FormInput>
                  <FormInput
                    wrapperCol={{ span: 14 }}
                    // labelCol={{ span: 10 }}
                    labelAlign="left"
                    col
                    xs={24}
                    name="gainifrecond"
                  >
                    <InputCurrency
                      currcode={
                        assetValues?.currcode ??
                        localStorage.getItem('currcode') ??
                        ''
                      }
                    />
                  </FormInput>
                  <FormInput
                    wrapperCol={{ span: 14 }}
                    // labelCol={{ span: 10 }}
                    labelAlign="left"
                    col
                    xs={24}
                    name="gainifsale"
                  >
                    <Value
                      formatter={(value) =>
                        toCurrency(
                          value,
                          assetValues?.currcode ??
                            localStorage.getItem('currcode') ??
                            ''
                        )
                      }
                    />
                  </FormInput>
                  <br />
                  <br />
                  <FormInput
                    col
                    xs={24}
                    name="actualmileage"
                    comcode="actualmileage"
                  >
                    <InputNumber onChange={updateAmountRecond} />
                  </FormInput>
                  <FormInput col xs={24} labelAlign="left" name="spformula">
                    <PricingListFilteredSelect
                      allowClear
                      disabled={state.isModSelected}
                      params={{
                        offerid: 0,
                        ctetype: 'SPFEES',
                        prcode: '',
                        entity: '',
                        entityid: 0,
                        tpid: 0,
                        filtersValue:
                          'NBKMS=' + form.getFieldValue('spvalue') + ',',
                      }}
                      onChange={(e) => {
                        calculateFees(e, 'SPFEES');
                        updateState({
                          totalspamount: '' as any,
                        });
                        form?.setFieldsValue({
                          spamount: '' as any,
                        });
                      }}
                    />
                  </FormInput>
                  <FormInput col xs={24} name="spamount" comcode="spamount">
                    <Value
                      formatter={(value) =>
                        toCurrency(
                          state.totalspamount,
                          form.getFieldValue('currcode') ??
                            localStorage.getItem('currcode') ??
                            ''
                        )
                      }
                    />
                  </FormInput>
                </Col>
              </Row>
            </UtinaCard>
          </Row>
          <Divider>
            <GetLabel label="decision" />
          </Divider>
          <Card type="inner">
            <Row gutter={32}>
              <Col span={8}>
                <Row gutter={16}>
                  <FormInput
                    col
                    xs={24}
                    name="repdecision"
                    comcode="repdecision"
                  >
                    <ParListSelect parcode="ASSETSTAT" parvalueparent="STOCK" />
                  </FormInput>
                </Row>
              </Col>
              <Col span={16}>
                <FormInput name="repcomment" rules={[{ required: true }]}>
                  <TextArea
                    maxLength={255}
                    rows={5}
                    style={{ width: '100%' }}
                  />
                </FormInput>
              </Col>
            </Row>
          </Card>
        </Spin>
      </Form>
    </DF.Provider>
  );
};
export default TabEvaluateAsset;
